import * as React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';

export default function Multi({ value, filterKey, updateState, inputName, options }) {
    const handleChange = (event, newValue) => {
        const ids = newValue.map(item => item.id);
        updateState({ [filterKey]: ids });
    };

    const selectedValue = options.filter(option => (value || []).includes(option.id));

    return (
        <Stack spacing={3}>
            <Autocomplete
                fullWidth={true}
                multiple
                size="small"
                id="tags-outlined-multi"
                options={options}
                getOptionLabel={(option) => option.name}
                value={selectedValue}
                onChange={handleChange}
                filterSelectedOptions
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={inputName}
                    />
                )}
            />
        </Stack>
    );
}